export default "__VITE_ASSET__DfVKHAbj__"